// Verbatim copy of Henry's listing checklist (from his "check list - Sheet2.csv").
// Column A = a stage or numbered sub-section header; an empty column A means the
// row is a task under the most recent header. This raw text is transformed into
// a Task Template object by parseChecklistCsv() in ./checklistParser.js.
// Keep this faithful to the source; edit the parser for behavior, not this data.

export const RAW_STARTER_CSV = `CMAs,
,Listing Form
,Create listing paperwork in TransactionDesk
,Create transaction in TransactionDesk
Listing Appointment,
,LC: Create green listing folder
,LC: Confirm appointment by email; note pre-listing packet; coordinate drop-off
,LC/EA: Make sure lead is on lead tracker
,EA: Drop off pre-listing packet
,LC: Send appointment reminder 1 day before
3 - Documents Needed From Seller (0/7),
,LBP (if applicable)
,Utility Information Sheet
,All About You
,Home Updates Sheet
,Seller Letter
,Seller's Property Disclosure
,Past Seller's Disclosure
4 - Home Prep (7/13),
,LC: Schedule pre-inspection and radon (if requested)
,LC: Schedule city inspection TISH (if required)
,LC: Schedule staging consultation (or bid) if needed
,LC: Measuring (appraiser or Spacecrafting)
,LC/EA: Lockbox on
,EA: Scan in notes and add to drive
,LC: Schedule staging install (if applicable)
,LC: Check in on TISH Report status if not received
,"LC: If vacant, turn on lights & flush system before showings"
,LC: Set up any vendors that need a bid
,LC: Received all bids back from vendors
,LC: Send bids to seller in one email
,"LC: Once seller decides work, create timeline and send"
5 - Listing Prep (0/27),
,LC: Write brochure text and specs
,LC: MLS input ready for CS status
,LC: Schedule photography; send appt time to seller
,LC: Order yard sign
,LC: Send completed photos to sellers for review
,LC: Get price confirmation initialed; send to front desk
,LC: Upload all supplements to MLS as one document
,LC: Upload all supplements to ShowingTime
,LC: Send 'now active' email to clients
,Send 'coming soon' email to sellers
,LC: Add agent branding to Spacecrafting tour
,LC: Add property info to Spacecrafting tour
,LC: Once sign installed add the rider
,Set up Reverse Home Search
,LC: Create My Deals for listing and upload docs
,LC: Send 3D tour and Floorplan to seller for approval
,LC: Review Floorplan; send back changes
,LC: Check if Process Street filled; send reminder
,LC: Review Process Street; organize updates & add to drive
,LC: Set up showing instructions
,LC: Order HOA docs or wait until offer
,LC: Check if SD completed; remind sellers
,LC: Review SD; reach out for changes
,"LC: If occupied, schedule walk-through before photos"
,LC: Just listed postcard - build address list & add to drive
,LC: Add photo captions
,LC: Upload CS to My Deals
6 - Marketing Materials (0/9),
,Feature Sheet (15)
,Seller Disclosure (6)
,TISH (6)
,Utility Sheet (5)
,Home Updates Sheet (5)
,Seller Letter (1 framed)
,Brochures (25)
,Condo/Townhome: Building Information Cards
,Floorplan (6)
7 - COMING SOON (0/6),
,Marketing folders in brochure stand
,Brochure box with brochures
,Supra lockbox
,Coming soon sign
,Remove your shoes sign
,"If Winter, bring mat for front door"
Under Contract,
,"Seller- Status change in MLS (TNAS,i OR Active,i/r)"
,Send seller / buyer accepted offer email
,Confirm earnest money received
,Send agent an email with details
,Ask Randy for commission split
,Add to CORE Sheets (closing & call sheets)
,Confirm we have received All About You
,Add to Randy's escrow tracker
,Print submitted My Deals sheet for Randy
,Send purchase agreement to closer & coordinator
,"My Deals: Submit PA, contact info, agent flat fee, title, EM, est. of proceeds"
,Update Trello card with agent/title/lender info & key dates
,Move Google Drive folder to Pending/Escrow
,Send intro email to Loan Officer with closer details & PA
,Seller- Send Estimate of Proceeds via DocuSign
,Add to Closing Gifts list
,Commission spreadsheet
,Check for reimbursements/invoices for settlement statement
,Check if buyers want a sewer scope inspection
,LC: Order HOA documents if applicable
,Add Deal in Henry's system
,Add Agent Info in Google Contacts
Pending,
,Notify Buyer / Seller of appraisal results
,Send out closing reminders
,Confirm/request work orders for inspection items (3 days prior)
,Seller- Ask agent to grab keys from lock box
,Follow-up Final Commitment Letter - 48 hour reminder
,Seller- Request new address if applicable
,EA/LC: Put up sold sign and pick up marketing materials
,Seller- Schedule de-staging
,Seller- Order Shutterfly book
,Seller- Change MLS status to 'pending'
,Email LO to ask when appraisal is being ordered
,Follow up with LO for appraisal results
,Seller- Confirm Process Street information transfer filled
,Confirm Commitment Letter received from LO
,Seller- Send commitment letter to sellers
,Seller- Wrap Shutterfly book
,Add inspection amendment items to Work To Do sheet
,Check again for reimbursements/invoices
,Seller- Check for extra keys in green file
,LC: Order sign down (around closing date)
,LC: Stop reverse search
,LC: Just SOLD postcard send out
Closed,
,Send out Zillow/Google Review email (if Henry says to)
,Scan in Settlement Statement
,Move Google Drive folder to Closed
,"Update contacts - new address, closing date & gift, labels"
,LC: Sellers- Pick up lockbox and sold sign
,Scan file (green folder) into drive
,Move Gmail folder to Closed label
,LC: Once closed: Remove 3d tour and mark sold on MLS
,LC: Mark LB back into central to do list and SUPRA`;
